<template>
    <el-container style="height: calc(100vh - 52px)">
        <el-header style="height: auto;" class="bg-gray-200 p-3 md:p-5">
            <div class="flex w-full flex-col md:flex-row">
                <!-- 検索部 -->
                <div class="hidden md:block bg-white border-2 border-gray-400 rounded-md p-4">
                    <el-form :model="searchForm" label-width="auto" label-position="top">
                        <div class="grid md:grid-cols-2 gap-4">
                            <el-form-item class="no-margin" label="組織名">
                                <el-input v-model="searchForm.organization_name" placeholder="組織名を入力" />
                            </el-form-item>

                            <div class="flex justify-end mt-7">
                                <el-button class="hidden md:block w-24" type="info"
                                    @click="handleSearchButton">検索</el-button>
                            </div>
                        </div>
                    </el-form>
                </div>

                <el-drawer class="md:hidden bg-gray-200" v-model="drawer" title="検索" direction="ttb" :with-header="false" size="auto">
                    <div class="bg-white border-2 border-gray-400 rounded-md p-4">
                        <el-form :model="searchForm" label-width="auto" label-position="top">
                            <div class="grid gap-4">
                                <div class="flex">
                                    <el-form-item class="no-margin flex-grow" label="組織名">
                                        <el-input v-model="searchForm.organization_name" placeholder="組織名を入力" />
                                    </el-form-item>

                                    <div class="flex justify-end mt-7">
                                        <el-button class="md:hidden ml-3" type="info" @click="handleSearchButton" circle>
                                            <el-icon>
                                                <span class="material-symbols-outlined">manage_search</span>
                                            </el-icon>
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </el-drawer>

                <!-- 操作部 -->
                <div class="flex justify-end items-center md:flex-grow">
                    <el-button class="custom-icon-btn md:hidden" type="info" 
                        @click="drawer = true" circle>
                        <span class="material-symbols-outlined">
                            manage_search
                        </span>
                    </el-button>

                    <el-button class="custom-icon-btn md:hidden" type="info"
                        @click="handleAddButton" circle>
                        <span class="material-symbols-outlined">
                            add
                        </span>
                    </el-button>
                    <el-button class="hidden md:block w-24" type="info"
                        @click="handleAddButton">新規登録</el-button>

                    
                    <el-upload v-if="loginUserRole === ROLES.SYSTEM || (loginUserRole === ROLES.ADMIN && loginUserRoleIsHead)" class="" ref="upload" :on-change="handleImportButton" :auto-upload="false"
                        :show-file-list="false" accept=".csv">
                        <el-tooltip content="CSVインポート" placement="top">
                            <el-button class="custom-icon-btn mx-3" type="info" circle>
                                <span class="material-symbols-outlined">
                                    upload_2
                                </span>
                            </el-button>
                        </el-tooltip>
                    </el-upload>

                    <el-button class="custom-icon-btn" type="info" 
                        @click="handleExportButton" circle>
                        <el-tooltip content="CSVエクスポート" placement="top">
                            <span class="material-symbols-outlined">
                                download_2
                            </span>
                        </el-tooltip>
                    </el-button>
                </div>
            </div>
        </el-header>

        <el-mian style="padding-bottom: 20px;">
            <!-- 手机CARD部 -->
            <div class="md:hidden" v-loading="loading" style="height: calc(100vh - 177px)">
                <div class="custom-title flex flex-col">
                    <span>組織マスタ（組織名　払い出し操作者必須）</span>
                    <div class="ml-auto">                        
                        <div class="flex items-center space-x-1">
                            <span class="text-white">ソート:</span>
                            <el-button 
                                size="small" 
                                @click="handleSort('name')"
                                :class="['mobile-sort-btn', sortField === 'name' ? 'active' : '']">
                                組織名    
                            </el-button>
                            <span class="text-white">アイテム数: {{ mTotalRecords }}</span>
                        </div>
                    </div>
                </div>
                
                <div style="height: calc(100vh - 227px); overflow-y: auto;">
                    <el-card style="border: 1px solid #d1d5db; border-radius: 0px"
                        v-for="item in mTableData" :key="item.organization_id">
                        <el-row align="middle">
                            <el-col :span="2">
                                <el-button
                                    class="w-8 h-16"
                                    type="info" 
                                    style="background-color: #b7b7b7;"
                                    text
                                    bg
                                    @click="handleEditButton(item)">
                                    <span>詳<br>細</span>
                                </el-button>
                            </el-col>

                            <el-col :span="18" class="ml-2">
                                <div>{{ item.name }}</div>
                                <el-switch v-model="item.is_pay_must" active-value="1" inactive-value="0"
                                    @change="handlePayMustChange(item)" />
                                <!-- ==================== [Change Block Start] 可回退: 手机端新增组织开关 ==================== -->
                                <!-- 修改前:
                                (无“下位部署ユーザーの払い出し許可”开关)
                                -->
                                <div class="text-xs text-gray-500 mt-1">下位部署ユーザーの払い出し許可</div>
                                <el-switch v-model="item.is_sub_pay_to_head_enabled" active-value="1" inactive-value="0"
                                    @change="handlePayMustChange(item)" />
                                <!-- ==================== [Change Block End] 可回退 ==================== -->
                            </el-col>

                            <el-col :span="2" class="ml-2" align="right">
                                <span v-if="item.organization_id !== SYSTEM_ORGANIZATION" 
                                    class="material-symbols-outlined cursor-pointer" 
                                    @click="handleDeleteButton(item)">
                                    delete
                                </span>
                            </el-col>
                        </el-row>
                    </el-card>
                </div>
            </div>

            <!-- WEB表格部 -->
            <div class="hidden md:block w-full">
                <el-table :data="mTableData" height="calc(100vh - 260px)" v-loading="loading">
                    <el-table-column label="組織マスタ" width="100" align="center">
                        <template #default="scope">
                            <el-button
                                class="w-12"
                                type="info"
                                style="background-color: #b7b7b7;"
                                text
                                bg
                                @click="handleEditButton(scope.row)">
                                <span>詳細</span>
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="organization_id" label="コード">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('organization_id')">
                                <span>{{ getSortLabel('organization_id') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'organization_id' }">
                                        {{ getSortIcon('organization_id') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="組織名">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('name')">
                                <span>{{ getSortLabel('name') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'name' }">
                                        {{ getSortIcon('name') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="is_pay_must" label="払い出し操作者必須" align="center">
                        <template #default="scope">
                            <el-switch v-model="scope.row.is_pay_must" active-value="1"
                                inactive-value="0" @change="handlePayMustChange(scope.row)" />
                        </template>
                    </el-table-column>
                    <!-- ==================== [Change Block Start] 可回退: PC端新增组织开关列 ==================== -->
                    <!-- 修改前:
                    (无 is_sub_pay_to_head_enabled 列)
                    -->
                    <el-table-column prop="is_sub_pay_to_head_enabled" label="下位部署ユーザーの払い出し許可" align="center">
                        <template #default="scope">
                            <el-switch v-model="scope.row.is_sub_pay_to_head_enabled" active-value="1"
                                inactive-value="0" @change="handlePayMustChange(scope.row)" />
                        </template>
                    </el-table-column>
                    <!-- ==================== [Change Block End] 可回退 ==================== -->
                    <el-table-column prop="updated_date" label="更新日">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('updated_date')">
                                <span>{{ getSortLabel('updated_date') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'updated_date' }">
                                        {{ getSortIcon('updated_date') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                        <template #default="{ row }">
                            {{ moment(row.updated_date).format('YYYY-MM-DD HH:mm:ss') }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="created_by" label="作成者">
                        <template #header>  
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('created_by')">
                                <span>{{ getSortLabel('created_by') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'created_by' }">
                                        {{ getSortIcon('created_by') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="削除" width="52" align="center">
                        <template #default="scope">
                            <span v-if="scope.row.organization_id !== SYSTEM_ORGANIZATION" 
                                class="material-symbols-outlined cursor-pointer mt-2" 
                                @click="handleDeleteButton(scope.row)">
                                delete
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页部 -->
            <div class="flex w-full justify-end mt-4">
                <div class="hidden md:block mr-3">
                    <el-pagination v-model:current-page="mCurrentPage" v-model:page-size="mPageSize"
                        :page-sizes="[10, 20, 50, 100]" layout="total, sizes, prev, pager, next, jumper"
                        :total="mTotalRecords" @size-change="handleSizeChange" @current-change="handlePageChange" />
                </div>

                <div class="md:hidden">
                    <el-pagination layout="prev, pager, next" :total="mTotalRecords"
                    @current-change="handlePageChange" />
                </div>
            </div>
        </el-mian>
    </el-container>

    <!-- 新規登録更新对话框 -->
    <el-dialog class="custom-dialog" modal-class="custom-dialog-modal" v-model="dialogFormVisible" :title="form.add_update === 'add' ? '新規登録' : '詳細'" align-center>
        <el-form :model="form" :rules="rules" ref="formRef" label-width="140px">
            <el-form-item label="コード" prop="organization_id">
                <el-input v-model="form.organization_id" autocomplete="off" :disabled="form.add_update === 'update'"
                    placeholder="コード" />
            </el-form-item>
            <el-form-item label="組織名" prop="name">
                <el-input v-model="form.name" autocomplete="off" placeholder="組織名" />
            </el-form-item>
            <el-form-item label="払い出し操作者必須" prop="is_pay_must">
                <el-switch v-model="form.is_pay_must" active-value="1"
                    inactive-value="0" />
            </el-form-item>
            <!-- ==================== [Change Block Start] 可回退: 弹窗新增组织开关 ==================== -->
            <!-- 修改前:
            (无 is_sub_pay_to_head_enabled 字段)
            -->
            <el-form-item label="下位部署ユーザーの払い出し許可" prop="is_sub_pay_to_head_enabled">
                <el-switch v-model="form.is_sub_pay_to_head_enabled" active-value="1"
                    inactive-value="0" />
            </el-form-item>
            <!-- ==================== [Change Block End] 可回退 ==================== -->
        </el-form>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="dialogFormVisible = false">キャンセル</el-button>
                <el-button type="primary" @click="handleAddUpdateSubmit(formRef)">
                    {{ form.add_update === 'add' ? '登録' : '更新' }}
                </el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script lang="ts">
import axios, { AxiosResponse } from 'axios';
import { ElMessage, ElMessageBox, ElPagination, ElTable, ElTableColumn } from 'element-plus';
import { defineComponent, onMounted, ref, nextTick, watch } from 'vue';
import type { FormInstance, FormRules, UploadFile } from 'element-plus';
import { Delete, Edit, Search, Plus } from '@element-plus/icons-vue';
import { ErrorCode, ImportResponseData, ResponseData, ResponseStatus } from '@/components/common/response';
import { getErrorMessage, PageType } from '@/components/common/errorMessage';
import { Operation, SearchRequest } from '@/components/common/request';
import moment from 'moment';
import { CSV_MAX_SIZE, SYSTEM_ORGANIZATION, ROLES } from '@/config/constants';
import { sortingUtil, type SortConfig } from '@/components/common/SortingUtil';

interface OrganizationInfo {
    add_update?: Operation,
    organization_id: string,
    name: string,
    address?: string,
    is_pay_must?: string,
    // ==================== [Change Block Start] 可回退: 前端组织模型新增字段 ====================
    // 修改前:
    // (无 is_sub_pay_to_head_enabled)
    is_sub_pay_to_head_enabled?: string,
    // ==================== [Change Block End] 可回退 ====================
    created_by?: string,
    created_date?: string,
    updated_by?: string,
    updated_date?: string,
}

export default defineComponent({
    name: 'MngOrgnization',
    components: {
        ElTable,
        ElTableColumn,
        ElPagination,
        Delete,
        Plus,
        Edit,
        Search,
    },
    setup() {
        const searchForm = ref<any>({
            organization_name: '',
        });

        const form = ref<OrganizationInfo>({
            add_update: Operation.unknow,
            organization_id: '',
            name: '',
            is_pay_must: '0',
            // ==================== [Change Block Start] 可回退: 新增组织时默认关闭 ====================
            // 修改前:
            // (无 is_sub_pay_to_head_enabled)
            is_sub_pay_to_head_enabled: '0',
            // ==================== [Change Block End] 可回退 ====================
        });

        const loginUserRole = localStorage.getItem('role');
        const loginUserRoleIsHead = localStorage.getItem('is_head') === '1';


        const drawer = ref(false);

        const loading = ref<boolean>(true);
        const hasMoreData = ref<boolean>(false); // 添加hasMoreData状态

        const size = ref<string>('small');
        const disabled = ref<boolean>(false);
        const background = ref<boolean>(true);

        const dialogFormVisible = ref<boolean>(false);

        const formRef = ref<FormInstance>()
        const rules = ref<FormRules>({
            organization_id: [
                { required: true, message: 'コードを入力してください', trigger: 'blur' },
                { min: 1, max: 20, message: 'コードは1〜20文字の間で入力してください', trigger: 'blur' }
            ],
            name: [
                { required: true, message: '組織名を入力してください', trigger: 'blur' },
                { min: 2, max: 50, message: '組織名は2〜50文字の間で入力してください', trigger: 'blur' }
            ]
        })

        const sortConfig: SortConfig = {
            organization_id: {
                label: 'コード',
                mobileLabel: 'コード',
                type: 'string' as const,
                defaultOrder: 'asc' as const
            },
            name: {
                label: '組織名',
                mobileLabel: '組織名',
                type: 'string' as const,
                defaultOrder: 'asc' as const
            },
            updated_date: {
                label: '更新日',
                mobileLabel: '更新日',
                type: 'date' as const,
                defaultOrder: 'desc' as const
            },
            created_by: {
                label: '作成者',
                mobileLabel: '作成者',
                type: 'string' as const,
                defaultOrder: 'desc' as const
            },
        };

        const allOrganizations = ref<OrganizationInfo[]>([]);

        const {
            handleSort,
            getSortLabel,
            getSortIcon,
            paginatedData: mTableData,
            totalRecords: mTotalRecords,
            totalPages: mTotalPages,
            currentPage: mCurrentPage,
            pageSize: mPageSize,
            handleSizeChange,
            handlePageChange,
            sortField,
            sortOrder,
            showMoreDataAlert,
        } = sortingUtil(
            allOrganizations,  
            sortConfig, 
        );

        /***** マウント **************************/
        onMounted(() => {
            getOrganizationList();
        });

        /***** ボタン **************************/
        const handleSearchButton = () => {
            drawer.value = false;
            mCurrentPage.value = 1;
            getOrganizationList();
        };

        const handleAddButton = () => {
            dialogFormVisible.value = true;
            nextTick(() => {
                formRef.value?.resetFields();
                form.value = {
                    add_update: Operation.add,
                    organization_id: '',
                    name: '',
                    is_pay_must: '0',
                    // ==================== [Change Block Start] 可回退: 新建弹窗默认关闭 ====================
                    // 修改前:
                    // (无 is_sub_pay_to_head_enabled)
                    is_sub_pay_to_head_enabled: '0',
                    // ==================== [Change Block End] 可回退 ====================
                };
            });
        };

        const handleEditButton = (row: OrganizationInfo) => {
            dialogFormVisible.value = true;
            nextTick(() => {
                formRef.value?.resetFields();
                form.value = {
                    add_update: Operation.update,
                    organization_id: row.organization_id,
                    name: row.name,
                    is_pay_must: row.is_pay_must,
                    // ==================== [Change Block Start] 可回退: 编辑时回填新增字段 ====================
                    // 修改前:
                    // (无 is_sub_pay_to_head_enabled)
                    is_sub_pay_to_head_enabled: row.is_sub_pay_to_head_enabled ?? '0',
                    // ==================== [Change Block End] 可回退 ====================
                };
            });
        };

        const handleDeleteButton = (row: OrganizationInfo) => {
            ElMessageBox.confirm('削除しますか？', '削除', {
                confirmButtonText: '削除',
                cancelButtonText: 'キャンセル',
                type: 'warning',
            }).then(() => {
                deleteOrganization(row);
            }).catch(() => {
                // console.log('削除キャンセル');
            });
        };

        const handleExportButton = () => {
            ElMessageBox.confirm('組織マスタをエクスポートしますか？', 'CSVエクスポート', {
                confirmButtonText: 'エクスポート',
                cancelButtonText: 'キャンセル',
                type: 'warning',
            }).then(() => {
                exportOrganization();
            }).catch(() => {
                // console.log('削除キャンセル');
            });
        };

        const handleAddUpdateSubmit = async (formEl: FormInstance | undefined) => {
            if (!formEl) return
            await formEl.validate((valid, fields) => {
                if (valid) {
                    if (form.value.add_update === Operation.add) {
                        addOrganization();
                    } else if (form.value.add_update === Operation.update) {
                        updateOrganization(form.value);
                    }
                    dialogFormVisible.value = false;
                }
            })
        }

        /***** DB 操作 **************************/
        const getOrganizationList = async () => {
            try {
                loading.value = true;
                const params: SearchRequest = {
                    // exact match toogle
                    organization_name: searchForm.value.organization_name,
                };
                
                const res: AxiosResponse<ResponseData<OrganizationInfo[]>> = await axios.get('/api/organizations/search', { params });
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    const { data, hasMoreData } = res.data;

                    allOrganizations.value = data || [];
                    showMoreDataAlert(hasMoreData || false);

                } else {
                    ElMessage.error(getErrorMessage(PageType.ORGANIZATION, res.data.code));
                }

            } catch (error) {
                ElMessage.error(getErrorMessage(PageType.ORGANIZATION));
            } finally {
                loading.value = false;
            }
        };

        const addOrganization = async () => {
            try {
                const res: AxiosResponse<ResponseData<OrganizationInfo>> = await axios.post('/api/organizations', form.value);
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    getOrganizationList();
                } else {
                    ElMessage.error(getErrorMessage(PageType.ORGANIZATION, res.data.code));
                }
            }
            catch (error) {
                ElMessage.error(getErrorMessage(PageType.ORGANIZATION));
            }
        };

        const updateOrganization = async (row: OrganizationInfo) => {
            try {
                const res: AxiosResponse<ResponseData<OrganizationInfo>> = await axios.put(`/api/organizations/${row.organization_id}`, row);
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    getOrganizationList();
                } else {
                    ElMessage.error(getErrorMessage(PageType.ORGANIZATION, res.data.code));
                }
            }
            catch (error) {
                ElMessage.error(getErrorMessage(PageType.ORGANIZATION));
            }
        };

        const deleteOrganization = async (row: OrganizationInfo) => {
            try {
                const res: AxiosResponse<ResponseData> = await axios.delete(`/api/organizations/${row.organization_id}`);
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    getOrganizationList();
                } else {
                    ElMessage.error(getErrorMessage(PageType.ORGANIZATION, res.data.code));
                }
            }
            catch (error) {
                ElMessage.error(getErrorMessage(PageType.ORGANIZATION));
            }
        };

        const exportOrganization = async () => {
            try {
                const res: AxiosResponse<any> = await axios.post(`/api/organizations/export`,{
                    responseType: 'blob'  // 设置响应类型为 blob
                });
                if (res.status === ResponseStatus.SUCCESS && res.data.code === undefined) {
                     // 创建 Blob 对象并触发文件下载
                    const bom = '\uFEFF'; // UTF-8 BOM
                    const blob = new Blob([bom + res.data], { type: 'text/csv;charset=utf-8;' });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = '組織マスタ_'+ moment(new Date().toISOString()).format('YYYYMMDDHHmmss') +'.csv';  // 指定下载的文件名
                    link.click();
                } else {
                    ElMessage.error('CSVエクスポート失敗しました。');
                }
            }
            catch (error) {
                ElMessage.error('CSVエクスポート失敗しました。');
            }
        };

        const handleImportButton = (file: UploadFile) => {
            if (file.raw) {
                const formData = new FormData()
                formData.append('file', file.raw)

                //文件过大 100K
                if (file.raw.size > CSV_MAX_SIZE) {
                    ElMessage.error('ファイルが大きすぎます。');
                    return;
                }

                loading.value = true;
                axios.post('/api/organizations/import', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then((res: AxiosResponse<ImportResponseData>) => {
                    if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                        getOrganizationList();
                        ElMessage.success('CSVインポート成功');
                    }else{
                        ElMessage.error('CSVインポート失敗しました。');
                    }
                    
                }).catch(error => {
                    ElMessage.error('CSVインポート失敗しました。');
                }).finally(() => {
                    loading.value = false;
                })
            } else {
                ElMessage.error('ファイルが無効です')
            }
        }

        const handlePayMustChange = (row: OrganizationInfo) => {
            form.value = {
                add_update: Operation.update,
                organization_id: row.organization_id,
                name: row.name,
                is_pay_must: row.is_pay_must,
                // ==================== [Change Block Start] 可回退: 列表开关联动更新新增字段 ====================
                // 修改前:
                // (无 is_sub_pay_to_head_enabled)
                is_sub_pay_to_head_enabled: row.is_sub_pay_to_head_enabled ?? '0',
                // ==================== [Change Block End] 可回退 ====================
            };

            updateOrganization(form.value);
        };

        return {
            searchForm,
            form,
            dialogFormVisible,
            loading,
            mTableData,
            mCurrentPage,
            mPageSize,
            mTotalPages,
            mTotalRecords,
            hasMoreData,
            size,
            disabled,
            background,
            handlePayMustChange,
            handleSearchButton,
            handleAddButton,
            handleEditButton,
            handleDeleteButton,
            handleSizeChange,
            handlePageChange,
            handleAddUpdateSubmit,
            handleExportButton,
            handleImportButton,
            formRef,
            rules,
            SYSTEM_ORGANIZATION,
            drawer,
            moment,
            sortField,
            sortOrder,
            getSortLabel,
            getSortIcon,
            handleSort,
            showMoreDataAlert,
            loginUserRole,
            loginUserRoleIsHead,
            ROLES,
        }
    }
});
</script>

<style scoped>
.sort-header {
    cursor: pointer;
    user-select: none;
    transition: background-color 0.2s;
    white-space: nowrap;
    display: flex;
    align-items: center;
}

.sort-header:hover {
    background-color: #f5f7fa;
}

/* 确保表头内容不换行 */
:deep(.el-table .el-table__header-wrapper .el-table__header th) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* 手机端排序按钮样式 */
.mobile-sort-btn {
    padding: 1px 4px;
    font-size: 11px;
    border-radius: 3px;
    transition: all 0.2s;
    white-space: nowrap;
    min-width: auto;
    height: 20px;
    line-height: 1;
    background-color: white;
    border: 1px solid #d1d5db;
}

.mobile-sort-btn:hover {
    background-color: #f8f9fa;
    color: #409eff;
    border-color: #409eff;
}

.mobile-sort-btn.active {
    background-color: #e6f7ff;
    color: #409eff;
    border-color: #409eff;
}
</style>